import * as React from "react";
const MobileNumberSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#fff"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#fff"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#EF4136"
      fillRule="evenodd"
      d="M35.056 23.89a1 1 0 0 1 1.104-.884 10 10 0 0 1 8.833 8.822 1 1 0 1 1-1.987.224 8 8 0 0 0-7.067-7.058 1 1 0 0 1-.883-1.104Zm-7.151 2.772a1 1 0 0 0-.903 0c-.106.054-.24.17-.826.757l-.158.157c-.56.56-.711.722-.832.937-.14.25-.257.7-.256.986 0 .254.038.407.203.99a18.038 18.038 0 0 0 4.619 7.849 18.038 18.038 0 0 0 7.85 4.618c.582.166.735.203.989.204.286 0 .736-.116.986-.256.214-.121.376-.272.937-.832l.157-.158c.587-.587.703-.72.757-.827a1 1 0 0 0 0-.902c-.054-.107-.17-.24-.757-.827l-.195-.195c-.385-.386-.472-.465-.538-.507a1 1 0 0 0-1.09 0c-.066.042-.152.121-.538.507a2.704 2.704 0 0 1-.363.325l-.583-.813.583.813a2.045 2.045 0 0 1-1.724.294 2.49 2.49 0 0 1-.395-.16l-.024-.011a15.604 15.604 0 0 1-4.285-3.04 15.604 15.604 0 0 1-3.04-4.285l-.012-.024a2.493 2.493 0 0 1-.16-.395l.96-.28-.96.28a2.045 2.045 0 0 1 .294-1.724c.098-.136.212-.25.302-.34l.024-.023c.385-.386.464-.473.507-.538a1 1 0 0 0 0-1.09l.838-.546-.838.545c-.043-.065-.122-.152-.507-.538l-.195-.194c-.587-.588-.72-.703-.827-.757ZM26.1 24.878a3 3 0 0 1 2.708 0c.432.218.808.595 1.242 1.03l.096.096.195.195.063.063c.287.286.534.533.707.8l-.797.517.797-.518a3 3 0 0 1 0 3.27c-.173.267-.42.514-.707.8l-.063.063a6.299 6.299 0 0 0-.108.109v.005l-.002.006.014.03.037.076a13.603 13.603 0 0 0 2.652 3.736 13.603 13.603 0 0 0 3.735 2.652l-.432.901.432-.901.076.036.03.014h.006l.006-.002c.022-.02.051-.05.109-.107l.063-.063c.286-.287.532-.534.799-.707a3 3 0 0 1 3.27 0c.267.173.513.42.8.707l.063.063.194.195.096.095c.436.435.812.81 1.031 1.243a3 3 0 0 1 0 2.708c-.219.433-.595.808-1.03 1.243l-.097.095-.157.158-.068.068c-.465.465-.822.823-1.304 1.093-.55.31-1.34.515-1.971.513-.552-.002-.954-.116-1.473-.263l-.057-.017a20.039 20.039 0 0 1-8.717-5.128 20.04 20.04 0 0 1-5.129-8.718l-.016-.056c-.147-.519-.262-.921-.263-1.473a4.364 4.364 0 0 1 .512-1.971c.271-.482.628-.84 1.094-1.304l.068-.068.157-.158.096-.096c.434-.435.81-.812 1.243-1.03l.451.892-.451-.892Zm8.968 2.93a1 1 0 0 1 1.173-.79 6 6 0 0 1 4.74 4.74 1 1 0 0 1-1.963.384 4 4 0 0 0-3.16-3.16 1 1 0 0 1-.79-1.174Z"
      clipRule="evenodd"
    />
  </svg>
);
export default MobileNumberSVG;
